"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_1 = require("./styled");
const LoaderDots_1 = __importDefault(require("./LoaderDots"));
const Loader = ({ code, stage, buy }) => {
    const cryptoStage = stage === "crypto";
    return (react_1.default.createElement(styled_1.Wrapper, null,
        react_1.default.createElement(LoaderDots_1.default, null),
        react_1.default.createElement(styled_1.Text, null, cryptoStage && !buy ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: `sell.finding-${stage}`, values: { crypto: code } })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: `buy.finding-${stage}`, values: { crypto: code } })))));
};
exports.default = Loader;
//# sourceMappingURL=Loader.js.map